import { z } from 'zod'

export const CUSTOM_TEMPLATE_VISIBILITY = [
  {
    value: 'private',
    label: 'Only me',
    description: 'Just you can see and use this template.',
  },
  {
    value: 'internal',
    label: 'My team',
    description:
      'Everyone in your organization can see and use it. You and org admins can edit.',
  },
] as const

export type CustomTemplateVisibility =
  (typeof CUSTOM_TEMPLATE_VISIBILITY)[number]['value']

export const customTemplateFormSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200),
  body: z.string().min(1, 'Body is required').max(5000),
  description: z.string().min(1, 'Description is required').max(500),
  emoji: z.string().max(8),
  visibility: z.enum(['private', 'internal']),
})

export type CustomTemplateFormValues = z.infer<typeof customTemplateFormSchema>

export const customTemplateFormDefaults: CustomTemplateFormValues = {
  title: '',
  body: '',
  description: '',
  emoji: '📝',
  visibility: 'private',
}
